import { Component } from '@angular/core';
import { JitsiMeetingComponent } from '../../jitsi-meeting.component';

@Component({
  selector: 'patient-metting',
  imports: [JitsiMeetingComponent],
  templateUrl: './metting.component.html',
  styleUrl: './metting.component.css'
})
export class MettingComponent {

    config: any;

  constructor() {
    this.config = history.state;
    console.log(this.config);

  }


}
